import type {
  Paquete,
  RegistrarPaqueteRequest,
  RetirarPaqueteRequest,
  DevolverPaqueteRequest,
  AnularPaqueteRequest,
  GenerarUrlSubidaFotoRequest,
  UrlSubidaFotoResponse,
} from '@condo/contracts';
import { api } from './client.js';

export const paquetesApi = {
  registrar: (body: RegistrarPaqueteRequest) =>
    api.post<Paquete>('/paquetes', body),
  retirar: (id: string, body: RetirarPaqueteRequest) =>
    api.post<Paquete>(`/paquetes/${id}/retirar`, body),
  devolver: (id: string, body: DevolverPaqueteRequest) =>
    api.post<Paquete>(`/paquetes/${id}/devolver`, body),
  anular: (id: string, body: AnularPaqueteRequest) =>
    api.post<Paquete>(`/paquetes/${id}/anular`, body),
  listar: (query?: { estado?: string; unidadId?: string }) =>
    api.get<{ items: Paquete[] }>(`/paquetes`, { query }),
  listarPendientes: () => api.get<{ items: Paquete[] }>(`/paquetes/pendientes`),
  listarMis: () => api.get<{ items: Paquete[] }>(`/paquetes/mis`),
  getById: (id: string) => api.get<Paquete>(`/paquetes/${id}`),
  historialUnidad: (unidadId: string) =>
    api.get<{ items: Paquete[] }>(`/unidades/${unidadId}/paquetes`),
  fotoUploadUrl: (body: GenerarUrlSubidaFotoRequest) =>
    api.post<UrlSubidaFotoResponse>(`/paquetes/foto-upload-url`, body),
};
